// deepLinkPriceMismatch.reducer.ts
import * as DeepLinkPriceMismatchActions from '../actions/deeplink-price-mismatch.actions';
import * as DeepLinkPriceMismatchState from '../states/deeplink-price-mismatch.state';

export class State extends DeepLinkPriceMismatchState.State { }

export function reducer(state = DeepLinkPriceMismatchState.initialState, action: DeepLinkPriceMismatchActions.Actions): DeepLinkPriceMismatchState.State {
  switch (action.type) {
    case DeepLinkPriceMismatchActions.ActionTypes.UPDATE_PRICE_MISMATCH:
      return {
        ...state,
        priceMismatch: {
          isPriceMismatch: action.payload.isPriceMismatch,
          originalFlightPrice: action.payload.originalFlightPrice,
          newFlightPrice: action.payload.newFlightPrice
        }
      };
    case DeepLinkPriceMismatchActions.ActionTypes.RESET:
      return DeepLinkPriceMismatchState.initialState;
    default:
      return state;
  }
}

export const getPriceMismatch = (state: DeepLinkPriceMismatchState.State) => state.priceMismatch;
